import Yup from 'src/services/yup';
import appConfig from 'src/appConfig';
import { FORM_ERROR } from 'src/appConfig/constanst';
export const INTIAL = {
  firstName: '',
  lastName: '',
  email: '',
  mobile: '',
  type: '',
  role: '',
};
export const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required(FORM_ERROR.RequiredField)
    .max(appConfig.TEXT_MEDIUM_LENGTH, FORM_ERROR.TextShortMaxLength),
  lastName: Yup.string()
    .required(FORM_ERROR.RequiredField)
    .max(appConfig.TEXT_MEDIUM_LENGTH, FORM_ERROR.TextShortMaxLength),
  email: Yup.string().email(FORM_ERROR.EmailFormat).required().max(appConfig.TEXT_SHORT_LENGTH, FORM_ERROR.EmailLength),
  role: Yup.string().required(FORM_ERROR.RequiredField),
  mobile: Yup.string().required().phone(),
  companyOrLawFirm: Yup.string().required(FORM_ERROR.RequiredField),
});
